import { Link } from 'react-router-dom';
import { Week, STAGE_LABELS } from '../../types';
import { Badge } from '../ui/Badge';
import { Button } from '../ui/Button';

interface ApprovalCardProps {
  week: Week;
  onApprove: (weekId: string) => void;
  onReject: (weekId: string) => void;
  loading?: boolean;
}

export function ApprovalCard({ week, onApprove, onReject, loading }: ApprovalCardProps) {
  return (
    <div className="bg-white border border-falcon-gold/40 rounded-xl p-5 shadow-sm">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <Badge variant="warning">Needs Approval</Badge>
            <span className="text-xs text-gray-400 font-body">
              {STAGE_LABELS[week.stage]}
            </span>
          </div>
          <p className="font-display font-semibold text-falcon-navy truncate">
            {week.topic?.title ?? 'New week — no topic yet'}
          </p>
          {week.topic?.primary_keyword && (
            <p className="text-xs text-gray-500 mt-1 font-body">
              {week.topic.primary_keyword}
            </p>
          )}
        </div>
        <Link
          to={`/week/${week.id}`}
          className="text-xs text-falcon-blue hover:underline font-body flex-shrink-0"
        >
          Review content
        </Link>
      </div>

      <div className="flex items-center gap-2 mt-4">
        <Button
          size="sm"
          onClick={() => onApprove(week.id)}
          loading={loading}
          disabled={loading}
        >
          Approve
        </Button>
        <Button
          size="sm"
          variant="secondary"
          onClick={() => onReject(week.id)}
          disabled={loading}
        >
          Request Changes
        </Button>
      </div>
    </div>
  );
}
